module.exports = __webpack_public_path__ + "static/media/lock.ef2ec899.svg";